import { render } from "./body_main_banner9.vue?vue&type=template&id=b6b24810&scoped=true"
import script from "./body_main_banner9.vue?vue&type=script&lang=js"
export * from "./body_main_banner9.vue?vue&type=script&lang=js"

import "./body_main_banner9.vue?vue&type=style&index=0&id=b6b24810&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6b24810"]])

export default __exports__